import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class DataReport {
  /* 仓库总览列表 */
  static getWarehouseOverviewList(options) {
    let url = `/oa/api/data/report/warehouse/report?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 仓库明细列表 */
  static getWarehouseDetailsList(options) {
    let url = `/oa/api/data/report/warehouse/detail?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 客户总览列表 */
  static getCustomersOverviewList(options) {
    let url = `/oa/api/customer/data/report/overview?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 客户明细列表 */
  static getCustomersDetailsList(options) {
    let url = `/oa/api/customer/data/report/detail?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default DataReport;